import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-product-rail-skeleton',
  standalone: true,
  templateUrl: './product-rail-skeleton.component.html',
  styleUrls: ['./product-rail-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRailSkeletonComponent {}
